<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="商品名称">
                  <el-input  v-model="queryForm.productName"></el-input>
              </el-form-item>
              <el-form-item label="商品货号">
                  <el-input  v-model="queryForm.productNumber"></el-input>
              </el-form-item>
              <el-form-item label="商品分类">
                  <el-input  v-model="queryForm.categoryId"></el-input>
              </el-form-item>
<!--              <el-form-item label="商品类型">-->
<!--                  <el-input  v-model="queryForm.productType"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="是否上架">
                  <el-input  v-model="queryForm.isShow"></el-input>
              </el-form-item>
              <el-form-item label="本店价格">
                  <el-input  v-model="queryForm.shopPrice"></el-input>
              </el-form-item>
              <el-form-item label="库存数量">
                  <el-input  v-model="queryForm.stockSize"></el-input>
              </el-form-item>
<!--              <el-form-item label="所属店铺">-->
<!--                  <el-input  v-model="queryForm.shopId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="所属门店">
                  <el-input  v-model="queryForm.storeId"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopStoreTakeoutProductList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
<!--        <el-button-->
<!--          type="primary"-->
<!--          size="small"-->
<!--          icon="el-icon-plus"-->
<!--          @click="addShopStoreTakeoutProduct"-->
<!--        >新建</el-button>-->
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopStoreTakeoutProduct(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopStoreTakeoutProduct(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
<!--        <span-->
<!--          title="下载模板"-->
<!--          class="icon-box"-->
<!--          @click="importTemplate"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDown />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          class="icon-box"-->
<!--          title="导入数据"-->
<!--          @click="isImport"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowExportUp24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
<!--        <span-->
<!--          title="导出数据"-->
<!--          class="icon-box"-->
<!--          @click="exportShopStoreTakeoutProductList"-->
<!--        >-->
<!--          <Icon color="#606266">-->
<!--            <ArrowDownload24Regular />-->
<!--          </Icon>-->
<!--        </span>-->
        <span
          class="icon-box"
          @click="refreshShopStoreTakeoutProductList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
<!--      <el-tabs v-model='activeName' @tab-click='handleClick' v-if='countSaleStatus'>-->
<!--          <el-tab-pane label='' name='null'></el-tab-pane>-->
<!--          <el-tab-pane :label="`全部 (-->
<!--                    ${countSaleStatus['status_0']-->
<!--                    + countSaleStatus['status_1']-->
<!--                    + countSaleStatus['status_2']-->
<!--                    + countSaleStatus['status_3']-->
<!--                    + countSaleStatus['status_4']-->
<!--                } )`" name='all'></el-tab-pane>-->
<!--          <el-tab-pane :label="`已下架 ( ${countSaleStatus['status_0']} )`" name='soldUutStock'></el-tab-pane>-->
<!--          <el-tab-pane :label="`在售中 ( ${countSaleStatus['status_1']} )`" name='onSale'></el-tab-pane>-->
<!--          <el-tab-pane :label="`仓库中 ( ${countSaleStatus['status_2']} )`" name='warehouse'></el-tab-pane>-->
<!--          <el-tab-pane :label="`审核中 ( ${countSaleStatus['status_3']} )`" name='audit'></el-tab-pane>-->
<!--          <el-tab-pane :label="`未过审 ( ${countSaleStatus['status_4']} )`" name='untried'></el-tab-pane>-->
<!--          <el-tab-pane :label="`库存警戒  ( ${countSaleStatus['status_5']} )`"-->
<!--                       name='inventoryAlert'></el-tab-pane>-->
<!--          <el-tab-pane :label="`已售罄 ( ${countSaleStatus['status_6']} )`" name='soldOut'></el-tab-pane>-->


<!--      </el-tabs>-->


          <!-- 列表数据 -->
    <el-table
      :data="shopStoreTakeoutProductList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>




        <el-table-column :show-overflow-tooltip='true' align='left' prop='productName' label='商品信息'
                         width='150'>
            <template slot-scope='scope'>
                <div style='text-align: left'>名称：{{ scope.row.productName }}</div>
                <div style='text-align: left'>货号：{{ scope.row.productNumber }}</div>
                <div style='text-align: left'>类型：{{getProductTypeOne(scope.row.productType)}}</div>
                <!--                        <div style='text-align: left' v-if='scope.row.productType == 1'>类型：普通商品</div>-->
                <!--                        <div style='text-align: left' v-if='scope.row.productType == 2'>类型：积分商品</div>-->
                <!--                        <div style='text-align: left' v-if='scope.row.productType == 3'>类型：秒杀商品</div>-->
                <!--                        <div style='text-align: left' v-if='scope.row.productType == 4'>类型：拼团商品</div>-->
                <!--                        <div style='text-align: left' v-if='scope.row.productType == 5'>类型：砍价商品</div>-->
                <!--                        <div style='text-align: left' v-if='scope.row.productType == 6'>类型：虚拟商品</div>-->
            </template>
        </el-table-column>
        <el-table-column align='center' label='图片' width='150'>
            <template slot-scope='scope'>
                <el-image
                    @click='updateSrcList(scope.row.productPic)'
                    style='width: 80px; height: 80px'
                    :src='scope.row.productPic'
                    :preview-src-list='srcList'
                ></el-image>
            </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip='true' align='center' label='价格' width='150'>
            <template slot-scope='scope'>
                <div style='text-align: left'>
                    商品价格：{{ scope.row.shopPrice }}
                </div>
                <div style='text-align: left' v-if="scope.row.supplyPrice">
                    供货价格：{{ scope.row.supplyPrice }}
                </div>
                <div style='text-align: left' v-if="scope.row.wholesalePrice">批发价格：{{ scope.row.wholesalePrice }}</div>
                <div style='text-align: left'>市场价格：{{ scope.row.marketPrice }}</div>
                <div style='text-align: left'>成本价格：{{ scope.row.costPrice }}</div>
            </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip='true' align='center' label='商品状态' width='150'>
            <template slot-scope='scope'>
                <el-tag type='info' v-if='scope.row.isShow == 0'>{{ computeProductStatus(scope.row.isShow) }}
                </el-tag>
                <el-tag type='success' v-if='scope.row.isShow == 1'>{{ computeProductStatus(scope.row.isShow)
                    }}
                </el-tag>
                <el-tag type='info' v-if='scope.row.isShow == 2'>{{ computeProductStatus(scope.row.isShow) }}
                </el-tag>
                <el-tag type='warning' v-if='scope.row.isShow == 3'>{{ computeProductStatus(scope.row.isShow)
                    }}
                </el-tag>
                <el-tag type='danger' v-if='scope.row.isShow == 4'>{{ computeProductStatus(scope.row.isShow)
                    }}
                </el-tag>
            </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip='true' align='center' prop='stockSize' label='库存'
                         width='150'></el-table-column>
        <el-table-column :show-overflow-tooltip='true' align='center' prop='saleSize' label='已售' width='150'>
        </el-table-column>
        <el-table-column :show-overflow-tooltip='true' align='left' prop='productName'
                         label='所属门店' width='150'>
            <template slot-scope='scope'>
                <div v-if='scope.row.store'>{{ scope.row.store.storeName }}</div>
            </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip='true' align='center' prop='createTime' label='创建时间'
                         width='150'>
        </el-table-column>





      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopStoreTakeoutProduct(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopStoreTakeoutProduct(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopStoreTakeoutProduct(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
      <el-dialog :title='shopStoreTakeoutProductStates[shopStoreTakeoutProductState]' :visible.sync='showDialog' width='80%'
                 @close='closeDialog'>
          <ProductEdit
              ref='ProductEdit'
              @closeDialog='closeDialog'
              :shopStoreTakeoutProductState='shopStoreTakeoutProductState'
              :shopProduct='shopStoreTakeoutProduct'
          ></ProductEdit>
          <div slot='footer' class='flex justify-end'>
              <el-button @click='closeDialog'>关闭</el-button>
              <el-button type='primary' @click='submitForm' v-if="shopStoreTakeoutProductState != 'check'">确定</el-button>
          </div>
      </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exportExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import ProductEdit from '@/components/ShopStoreTakeout/ProductEdit.vue'

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        ProductEdit
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopStoreTakeoutProductList();
                    this.getShopStoreTakeoutProductList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopStoreTakeoutProductList();
                    this.getShopStoreTakeoutProductList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     productType: '', //商品类型
                     saleMode: '', //销售模式
                     productName: '', //商品名称
                     productNumber: '', //商品货号
                     shopPrice: '', //本店价格
                     marketPrice: '', //市场价格
                     costPrice: '', //成本价
                     supplyPrice: '', //供货价格
                     wholesalePrice: '', //批发价格
                     settlePrice: '', //结算价格
                     discount: '', //标准商品折扣
                     scoreDiscount: '', //积分商品折扣:暂未使用字段
                     productScore: '', //所需积分
                     giveScore: '', //赠送积分
                     extendField1: '', //
                     extendField2: '', //
                     extendField3: '', //
                     productPic: '', //缩略图
                     productVideo: '', //视频地址
                     productAlbum: '', //产品相册
                     productContent: '', //详细描述（内容）
                     categoryId: '', //分类ID
                     shopCategoryId: '', //店铺内分类ID
                     brandId: '', //品牌id
                     shopId: '', //
                     storeId: '', //门店ID
                     sort: '', //排序
                     isSelected: '', //是否精选 0非精选 1精选
                     isRecommend: '', //否是推荐 0不推荐 1推荐
                     isShow: '', //0下架，1上架
                     refuseReason: '', //拒绝理由
                     stockSize: '', //库存数量
                     saleSize: '', //销售数量
                     buyMinLimit: '', //起批数量
                     buyLimit: '', //限购数量
                     isFreightFree: '', //是否免运费 0：否  1：是
                     freightPrice: '', //运费
                     orderType: '', //订单类型
                     deliverMethod: '', //配送方式-暂未使用
                     inviterMobile: '', //推荐用户手机(暂未使用)
                },
                activeName: 'all',// tabs
                countSaleStatus: {
                    'status_1': 0,
                    'status_2': 0,
                    'status_3': 0,
                    'status_4': 0
                },// 获取商品状态的数量
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopStoreTakeoutProductState: 'add',
                shopStoreTakeoutProductStates: {
                    add: '新建商品',
                    check: '查看商品',
                    edit: '修改商品'
                },

                multipleSelection: [],
                shopStoreTakeoutProductList: [],
                shopStoreTakeoutProduct: {
                    id: '', //
                    productType: '', //商品类型
                    saleMode: '', //销售模式
                    productName: '', //商品名称
                    productNumber: '', //商品货号
                    shopPrice: '', //本店价格
                    marketPrice: '', //市场价格
                    costPrice: '', //成本价
                    supplyPrice: '', //供货价格
                    wholesalePrice: '', //批发价格
                    settlePrice: '', //结算价格
                    discount: '', //标准商品折扣
                    scoreDiscount: '', //积分商品折扣:暂未使用字段
                    productScore: '', //所需积分
                    giveScore: '', //赠送积分
                    extendField1: '', //
                    extendField2: '', //
                    extendField3: '', //
                    productPic: '', //缩略图
                    productVideo: '', //视频地址
                    productAlbum: '', //产品相册
                    productContent: '', //详细描述（内容）
                    categoryId: '', //分类ID
                    shopCategoryId: '', //店铺内分类ID
                    brandId: '', //品牌id
                    shopId: '', //
                    storeId: '', //门店ID
                    sort: '', //排序
                    isSelected: '', //是否精选 0非精选 1精选
                    isRecommend: '', //否是推荐 0不推荐 1推荐
                    isShow: '', //0下架，1上架
                    refuseReason: '', //拒绝理由
                    stockSize: '', //库存数量
                    saleSize: '', //销售数量
                    buyMinLimit: '', //起批数量
                    buyLimit: '', //限购数量
                    isFreightFree: '', //是否免运费 0：否  1：是
                    freightPrice: '', //运费
                    orderType: '', //订单类型
                    deliverMethod: '', //配送方式-暂未使用
                    inviterMobile: '', //推荐用户手机(暂未使用)
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    productType: [{ required: true, message: '商品类型不能为空', trigger: 'blur' }],
                    saleMode: [{ required: true, message: '销售模式不能为空', trigger: 'blur' }],
                    productName: [{ required: true, message: '商品名称不能为空', trigger: 'blur' }],
                    productNumber: [{ required: true, message: '商品货号不能为空', trigger: 'blur' }],
                    shopPrice: [{ required: true, message: '本店价格不能为空', trigger: 'blur' }],
                    marketPrice: [{ required: true, message: '市场价格不能为空', trigger: 'blur' }],
                    costPrice: [{ required: true, message: '成本价不能为空', trigger: 'blur' }],
                    supplyPrice: [{ required: true, message: '供货价格不能为空', trigger: 'blur' }],
                    wholesalePrice: [{ required: true, message: '批发价格不能为空', trigger: 'blur' }],
                    settlePrice: [{ required: true, message: '结算价格不能为空', trigger: 'blur' }],
                    discount: [{ required: true, message: '标准商品折扣不能为空', trigger: 'blur' }],
                    scoreDiscount: [{ required: true, message: '积分商品折扣:暂未使用字段不能为空', trigger: 'blur' }],
                    productScore: [{ required: true, message: '所需积分不能为空', trigger: 'blur' }],
                    giveScore: [{ required: true, message: '赠送积分不能为空', trigger: 'blur' }],
                    extendField1: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    extendField2: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    extendField3: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    productPic: [{ required: true, message: '缩略图不能为空', trigger: 'blur' }],
                    productVideo: [{ required: true, message: '视频地址不能为空', trigger: 'blur' }],
                    productAlbum: [{ required: true, message: '产品相册不能为空', trigger: 'blur' }],
                    productContent: [{ required: true, message: '详细描述（内容）不能为空', trigger: 'blur' }],
                    categoryId: [{ required: true, message: '分类ID不能为空', trigger: 'blur' }],
                    shopCategoryId: [{ required: true, message: '店铺内分类ID不能为空', trigger: 'blur' }],
                    brandId: [{ required: true, message: '品牌id不能为空', trigger: 'blur' }],
                    shopId: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    storeId: [{ required: true, message: '门店ID不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                    isSelected: [{ required: true, message: '是否精选 0非精选 1精选不能为空', trigger: 'blur' }],
                    isRecommend: [{ required: true, message: '否是推荐 0不推荐 1推荐不能为空', trigger: 'blur' }],
                    isShow: [{ required: true, message: '0下架，1上架不能为空', trigger: 'blur' }],
                    refuseReason: [{ required: true, message: '拒绝理由不能为空', trigger: 'blur' }],
                    stockSize: [{ required: true, message: '库存数量不能为空', trigger: 'blur' }],
                    saleSize: [{ required: true, message: '销售数量不能为空', trigger: 'blur' }],
                    buyMinLimit: [{ required: true, message: '起批数量不能为空', trigger: 'blur' }],
                    buyLimit: [{ required: true, message: '限购数量不能为空', trigger: 'blur' }],
                    isFreightFree: [{ required: true, message: '是否免运费 0：否  1：是不能为空', trigger: 'blur' }],
                    freightPrice: [{ required: true, message: '运费不能为空', trigger: 'blur' }],
                    orderType: [{ required: true, message: '订单类型不能为空', trigger: 'blur' }],
                    deliverMethod: [{ required: true, message: '配送方式-暂未使用不能为空', trigger: 'blur' }],
                    inviterMobile: [{ required: true, message: '推荐用户手机(暂未使用)不能为空', trigger: 'blur' }],
                },





                showShop: 0,
                productTypeEnumList: [],
                srcList: [""],
            };
        },
        created() {
            this.getProductType();
            this.getProductStatusEnum();
            this.getShopStoreTakeoutProductList();
            this.getCountSaleStatus();
            this.getShowShop();
        },
        methods: {
            // 获取showShop
            getShowShop() {
                get('/mall/shop/getShowShop').then((res) => {
                    if (res.success) {
                        this.showShop = res.showShop;
                    }
                });
            },
            // 获取产品分类枚举
            getProductType() {
                get('/mpp/utils/getEnum', {
                    enumType: 'product_type'
                }).then((res) => {
                    if (res.success) {
                        this.productTypeEnumList = res.enumList;
                    }
                });
            },
            getProductTypeOne(keys){
                // for (let productTypeEnumListKey in this.productTypeEnumList) {
                //     if(this.productTypeEnumList[productTypeEnumListKey].key == keys){
                //         return this.productTypeEnumList[productTypeEnumListKey].value
                //     }
                // }
                for (let i = 0; i < this.productTypeEnumList.length; i++) {
                    if (this.productTypeEnumList[i].key == keys) {
                        return this.productTypeEnumList[i].value;
                    }
                }
            },
            // 获取商品状态枚举
            getProductStatusEnum() {
                get('/mpp/utils/getEnum', {
                    enumType: 'product_status'
                }).then((res) => {
                    if (res.success) {
                        this.productStatusEnumList = res.enumList;
                    }
                });
            },

            // 计算商品状态
            computeProductStatus(type) {
                for (let i = 0; i < this.productStatusEnumList.length; i++) {
                    if (this.productStatusEnumList[i].key == type) {
                        return this.productStatusEnumList[i].value;
                    }
                }
            },





            search(){
                this.isSearch = !this.isSearch;
            },
            resetShopStoreTakeoutProductList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopStoreTakeoutProductList = [];
            },
            // tabs
            handleClick(tab) {
                switch (tab.$options.propsData.name) {
                    case 'all':
                        this.queryForm.isShow = '';
                        this.queryForm.miniStock = '';
                        this.queryForm.maxStock = '';
                        this.getShopStoreTakeoutProductList();
                        break;
                    case 'onSale':
                        this.queryForm.isShow = 1;
                        this.queryForm.miniStock = '';
                        this.queryForm.maxStock = '';
                        this.getShopStoreTakeoutProductList();
                        break;
                    case 'inventoryAlert':
                        this.queryForm.isShow = 1;
                        this.queryForm.miniStock = 1;
                        this.queryForm.maxStock = this.warnStock;
                        this.getShopStoreTakeoutProductList();
                        break;
                    case 'soldOut':
                        this.queryForm.isShow = 1;
                        this.queryForm.miniStock = 0;
                        this.queryForm.maxStock = 0;
                        this.getShopStoreTakeoutProductList();
                        break;
                    case 'soldUutStock':
                        this.queryForm.isShow = 0;
                        this.queryForm.miniStock = '';
                        this.queryForm.maxStock = '';
                        this.getShopStoreTakeoutProductList();
                        break;
                    case 'warehouse':
                        this.queryForm.isShow = 2;
                        this.queryForm.miniStock = '';
                        this.queryForm.maxStock = '';
                        this.getShopStoreTakeoutProductList();
                        break;
                    case 'audit':
                        this.queryForm.isShow = 3;
                        this.queryForm.miniStock = '';
                        this.queryForm.maxStock = '';
                        this.getShopStoreTakeoutProductList();
                        break;
                    case 'untried':
                        this.queryForm.isShow = 4;
                        this.queryForm.miniStock = '';
                        this.queryForm.maxStock = '';
                        this.getShopStoreTakeoutProductList();
                        break;
                }

            },
            resetDialog() {
                this.shopStoreTakeoutProductState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      productType: '', //商品类型
                      saleMode: '', //销售模式
                      productName: '', //商品名称
                      productNumber: '', //商品货号
                      shopPrice: '', //本店价格
                      marketPrice: '', //市场价格
                      costPrice: '', //成本价
                      supplyPrice: '', //供货价格
                      wholesalePrice: '', //批发价格
                      settlePrice: '', //结算价格
                      discount: '', //标准商品折扣
                      scoreDiscount: '', //积分商品折扣:暂未使用字段
                      productScore: '', //所需积分
                      giveScore: '', //赠送积分
                      extendField1: '', //
                      extendField2: '', //
                      extendField3: '', //
                      productPic: '', //缩略图
                      productVideo: '', //视频地址
                      productAlbum: '', //产品相册
                      productContent: '', //详细描述（内容）
                      categoryId: '', //分类ID
                      shopCategoryId: '', //店铺内分类ID
                      brandId: '', //品牌id
                      shopId: '', //
                      storeId: '', //门店ID
                      sort: '', //排序
                      isSelected: '', //是否精选 0非精选 1精选
                      isRecommend: '', //否是推荐 0不推荐 1推荐
                      isShow: '', //0下架，1上架
                      refuseReason: '', //拒绝理由
                      stockSize: '', //库存数量
                      saleSize: '', //销售数量
                      buyMinLimit: '', //起批数量
                      buyLimit: '', //限购数量
                      isFreightFree: '', //是否免运费 0：否  1：是
                      freightPrice: '', //运费
                      orderType: '', //订单类型
                      deliverMethod: '', //配送方式-暂未使用
                      inviterMobile: '', //推荐用户手机(暂未使用)
                };
                this.getShopStoreTakeoutProductList();
            },
            closeDialog(val) {
                this.showDialog = false
                this.shopStoreTakeoutProduct = {
                      id: '', //
                      productType: '', //商品类型
                      saleMode: '', //销售模式
                      productName: '', //商品名称
                      productNumber: '', //商品货号
                      shopPrice: '', //本店价格
                      marketPrice: '', //市场价格
                      costPrice: '', //成本价
                      supplyPrice: '', //供货价格
                      wholesalePrice: '', //批发价格
                      settlePrice: '', //结算价格
                      discount: '', //标准商品折扣
                      scoreDiscount: '', //积分商品折扣:暂未使用字段
                      productScore: '', //所需积分
                      giveScore: '', //赠送积分
                      extendField1: '', //
                      extendField2: '', //
                      extendField3: '', //
                      productPic: '', //缩略图
                      productVideo: '', //视频地址
                      productAlbum: '', //产品相册
                      productContent: '', //详细描述（内容）
                      categoryId: '', //分类ID
                      shopCategoryId: '', //店铺内分类ID
                      brandId: '', //品牌id
                      shopId: '', //
                      storeId: '', //门店ID
                      sort: '', //排序
                      isSelected: '', //是否精选 0非精选 1精选
                      isRecommend: '', //否是推荐 0不推荐 1推荐
                      isShow: '', //0下架，1上架
                      refuseReason: '', //拒绝理由
                      stockSize: '', //库存数量
                      saleSize: '', //销售数量
                      buyMinLimit: '', //起批数量
                      buyLimit: '', //限购数量
                      isFreightFree: '', //是否免运费 0：否  1：是
                      freightPrice: '', //运费
                      orderType: '', //订单类型
                      deliverMethod: '', //配送方式-暂未使用
                      inviterMobile: '', //推荐用户手机(暂未使用)
                };
                this.$refs.ProductEdit.closeDialog();

                if (val) {
                    // this.resetShopProductList();
                    this.getShopStoreTakeoutProductList();
                }
            },
            // 获取商品状态的数量
            getCountSaleStatus() {
                get('/shop/product/countSaleStatus').then((res) => {
                    if (res.success) {
                        this.countSaleStatus = res.map;
                    }
                });
            },
            submitForm() {
                if (this.shopStoreTakeoutProductState == 'add') {
                    this.$refs.shopStoreTakeoutProductForm.validate((valid) => {
                        if (valid) {
                            post(`/shop/storetakeoutproduct/add`, { ...this.shopStoreTakeoutProduct }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopStoreTakeoutProductList();
                                    this.getShopStoreTakeoutProductList();
                                    this.showDialog = false;
                                }
                            });
                        }
                    });
                } else if (this.shopStoreTakeoutProductState == 'edit') {
                    this.$refs.ProductEdit.submitForm();
                }
            },
            addShopStoreTakeoutProduct() {
                this.showDialog = true;
                this.shopStoreTakeoutProductState = 'add';
            },
            checkShopStoreTakeoutProduct(shopStoreTakeoutProductId) {
                console.log(shopStoreTakeoutProductId);
                this.currentShopStoreTakeoutProductId = shopStoreTakeoutProductId;

                this.getShopStoreTakeoutProductById();
                this.showDialog = true;
                this.shopStoreTakeoutProductState = 'check';
            },
            editShopStoreTakeoutProduct(shopStoreTakeoutProductId) {
                console.log('shopStoreTakeoutProduct', shopStoreTakeoutProductId);
                if (shopStoreTakeoutProductId) {
                    this.currentShopStoreTakeoutProductId = shopStoreTakeoutProductId;
                    this.getShopStoreTakeoutProductById();
                } else {
                    this.shopStoreTakeoutProduct = { ...this.shopStoreTakeoutProduct, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopStoreTakeoutProductState = 'edit';
            },
            deleteShopStoreTakeoutProduct(shopStoreTakeoutProductId) {
                let ids = '';
                if (shopStoreTakeoutProductId) {
                    ids = shopStoreTakeoutProductId;
                } else {
                    ids = this.multipleSelection.map((shopStoreTakeoutProduct) => shopStoreTakeoutProduct.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/storetakeoutproduct/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopStoreTakeoutProductList();
                                this.getShopStoreTakeoutProductList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopStoreTakeoutProductList() {
                this.resetShopStoreTakeoutProductList();
                this.getShopStoreTakeoutProductList();
            },
            getShopStoreTakeoutProductList(query = {}) {
                this.loading = true;
                get(`/shop/storetakeoutproduct/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopStoreTakeoutProductList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopStoreTakeoutProductById() {
                get(`/shop/storetakeoutproduct/get`,{ id: this.currentShopStoreTakeoutProductId }).then((res) =>{
                    if(res.success){
                      this.shopStoreTakeoutProduct = { ...this.shopStoreTakeoutProduct, ...res.shopStoreTakeoutProduct };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopStoreTakeoutProductList() {
                //this.btnLoading = true;
                exportExcel(`/shop/storetakeoutproduct/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/storetakeoutproduct/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/storetakeoutproduct/importData`,formData);
              this.refreshShopStoreTakeoutProductList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopStoreTakeoutProductList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopStoreTakeoutProductList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-dropdown {
    font-size: 12px;
    color: #409eff;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 200px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 200px;
    height: 200px;
    display: block;
}

.disUoloadSty .el-upload--picture-card {
    display: none;
}

.classInput {
    width: 200px;
}

.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
}

.el-icon-arrow-down {
    font-size: 12px;
}
</style>